import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-popupaddcategory',
  templateUrl: './popupaddcategory.component.html',
  styleUrls: ['./popupaddcategory.component.scss']
})
export class PopupaddcategoryComponent {
  categoryName: string = '';

  constructor(public dialogRef: MatDialogRef<PopupaddcategoryComponent>) {}

  onSave(): void {
    this.dialogRef.close(this.categoryName);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
